import { Transaction as TransactionType } from '../types';
import AdImage from '../../components/AdImage';
import NotificationDot from '../../components/NotificationDot';
import { createTransactionLink } from './utils';
import pulseClient from '../../pulse-tracking';

type Props = {
    transaction: TransactionType;
};

const Transaction = ({ transaction }: Props) => {
    const { adId, statusString, title, image } = transaction;

    const trackTransactionClick = () => pulseClient.trackAdClick(adId, statusString);
    const transactionLink = createTransactionLink(transaction);

    return (
        <article
            className={`tjt-transaction-item relative flex justify-between items-center flex-row-reverse p-12 mb-0 lg:mb-12 border border-solid s-border rounded-8 hover:s-bg-primary-subtle active:s-bg-primary-subtle-hover`}
        >
            <div className="pl-12 grow flex flex-col-reverse truncate">
                <h3 className="text-s font-normal mb-0 truncate">{title}</h3>
                <a
                    href={transactionLink}
                    className={`font-bold mb-0 s-text hover:no-underline truncate`}
                    onClick={trackTransactionClick}
                >
                    {statusString}
                </a>
            </div>

            <div className="relative shrink-0">
                <NotificationDot />
                <AdImage img={image} className="rounded-8 shadow-s w-48 h-48 object-cover" />
            </div>
        </article>
    );
};

export default Transaction;
